import styles from './style.module.css';

export default function Item({ active, selected, onSelect, doc }) {
	const [title, text] = doc?.list ?? [];
	const className = [styles['check-out'], styles[selected ? 'check-out-on' : 'check-out-off']].join(' ');
	const itemClass = [styles.item, active && styles['check-current'], selected && styles['check-out-border']].filter(Boolean).join(' ');
	return <div className={itemClass} onClick={() => onSelect(doc?.value?.[0])}>
		<div className={styles.col}>
			<div className={className}>
				{selected && <div className={styles['check-in']} />}
			</div>
		</div>
		<div className={styles.col}>
			<h4 className={styles.title}>{title}</h4>
			{text ? <p className={styles.text} dangerouslySetInnerHTML={{ __html: text }} /> : null}
		</div>
	</div>
}